export default __webpack_public_path__ + "img/Poppins-ExtraLight_d793847.ttf";